import { IconCalendar, IconHistorial, IconLogout, IconSearch, IconShield } from "../../icons/IconsPaciente";
import "./PacienteSidebar.css";

const NAV_ITEMS = [
    { key: "turnos", label: "Mis turnos", icon: <IconCalendar /> },
    { key: "buscar", label: "Reservar turno", icon: <IconSearch /> },
    { key: "directorio", label: "Directorio", icon: <IconHistorial /> },
];

const PacienteSidebar = ({ currentPage, activePage, onNavigate, user, onLogout }) => {
    const current = currentPage ?? activePage;
    return (
        <aside className="patient-sidebar">
            <a href="#patient-main-content" className="skip-link">Saltar al contenido principal</a>

            <div className="patient-sidebar__brand">
                <img
                    src="/logo192.png"
                    alt="Logo Sweet Medical"
                    className="admin-sidebar__logo"
                    style={{ width: '40px', height: '40px', objectFit: 'contain' }}
                />
                <span>Sweet Medical</span>
            </div>

            <div className="patient-sidebar__user">
                <div className="patient-sidebar__avatar" aria-hidden="true">
                    {(user?.displayName || user?.username || "U").charAt(0).toUpperCase()}
                </div>
                <div>
                    <p className="patient-sidebar__user-name">{user?.displayName || user?.username}</p>
                    <p className="patient-sidebar__user-role">Paciente</p>
                </div>
            </div>

            <nav className="patient-sidebar__nav" aria-label="Navegación principal del panel de paciente">
                {NAV_ITEMS.map((item) => (
                    <button
                        key={item.key}
                        className={`patient-sidebar__nav-item${current === item.key ? " patient-sidebar__nav-item--active" : ""}`}
                        onClick={() => onNavigate(item.key)}
                        aria-current={current === item.key ? "page" : undefined}
                    >
                        <span aria-hidden="true">{item.icon}</span>
                        <span>{item.label}</span>
                    </button>
                ))}
            </nav>

            <button className="patient-sidebar__logout" onClick={onLogout} aria-label="Cerrar sesión">
                <IconLogout aria-hidden="true" />
                <span>Cerrar sesión</span>
            </button>
        </aside>
    );
};

export default PacienteSidebar;